var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('r-link',{staticClass:"logo",attrs:{"route":"page-affirmation/list"}},[_c('img',{attrs:{"src":"/assets/img/logo.png","alt":"Affiro"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }